import { useQuery } from "urql";

import {
  GetCollectorsDocument,
  UserRoleFilterOptions,
  UserStatusFilterOptions,
} from "../../../graphql/generated.ts";

export const useRMonAssignees = () => {
  const variables = {
    filter: {
      role: {
        in: [
          UserRoleFilterOptions.RmonOfficer,
          UserRoleFilterOptions.RmonManager,
        ],
      },
      status: { equals: UserStatusFilterOptions.Active },
    },
  };
  return useQuery({
    query: GetCollectorsDocument,
    variables,
  });
};
